import AddContentModal from './add-content-modal-view';

export default AddContentModal;
